import PropTypes from 'prop-types';

import { SkeletonStyled } from './styles';

export default function Skeleton({ borderRadius, ...props }) {
  return (
    <SkeletonStyled
      {...props}
      sx={{ borderRadius }}
    />
  );
}

Skeleton.propTypes = {
  borderRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
